import get from 'lodash/get';

export const getAppPermissions = (permissions, appDSPermissions, name) => {
  if (!permissions) {
    return true;
  }
  if (
    name === 'Manage Users' &&
    (appDSPermissions.anyPaa || appDSPermissions.ia)
  ) {
    return true;
  }
  if (name === 'Manage 3rd Parties' && appDSPermissions.anyPaa) {
    return true;
  }

  return permissions
    .split(',')
    .some((permission) => get(appDSPermissions, permission));
};
